<template>
  <div>
    <!-- Form for editing the institute -->
    <form @submit.prevent="submitForm">
      <!-- Institute Name Input -->
      <div class="mb-3">
        <label for="name" class="form-label">Institute Name</label>
        <input type="text" id="name" v-model="localInstitute.institute_name" class="form-control" required>
      </div>

      <!-- Address Input -->
      <div class="mb-3">
        <label for="address" class="form-label">Address</label>
        <input type="text" id="address" v-model="localInstitute.address" class="form-control" required>
      </div>

      <!-- Contact Input -->
      <div class="mb-3">
        <label for="contact" class="form-label">Contact</label>
        <input type="text" id="contact" v-model="localInstitute.contact" class="form-control" required>
      </div>

      <!-- Location Select Dropdown -->
      <div class="mb-3">
        <label for="location" class="form-label">Location</label>
        <select v-model="localInstitute.location_id" class="form-select" required>
          <option v-for="location in locations" :key="location.id" :value="location.id">
            {{ location.name }}
          </option>
        </select>
      </div>
      

      <!-- User Details Section -->
      <div class="mb-3" v-if="localInstitute.user">
        <h3>User Details</h3>
        <label for="firstName" class="form-label">First Name</label>
        <input type="text" id="firstName" v-model="localInstitute.user.first_name" class="form-control">
        <label for="lastName" class="form-label">Last Name</label>
        <input type="text" id="lastName" v-model="localInstitute.user.last_name" class="form-control">

        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input type="email" id="email" v-model="localInstitute.user.email" class="form-control">
        </div>

        <div class="mb-3">
          <label for="profilePhoto" class="form-label">Profile Photo</label>
          <input type="file" id="profilePhoto" @change="handleFileUpload" class="form-control">
          <div v-if="previewImage" class="mt-2">
            <img :src="previewImage" alt="Profile Photo Preview" class="img-fluid">
          </div>
        </div>
      </div>

      <button type="submit" class="btn btn-primary" :disabled="loading">
        <span v-if="loading">Saving...</span>
        <span v-else>Save Changes</span>
      </button>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    institute: {
      type: Object,
      default: () => ({
        institute_name: '',
        address: '',
        contact: '',
        location_id: null,
        user: {
          first_name: '',
          last_name: '',
          email: '',
          profile_photo_url: ''
        }
      })
    }
  },
  data() {
    return {
      localInstitute: this.institute ? { ...this.institute } : {
        institute_name: '',
        address: '',
        contact: '',
        location_id: null,
        user: {
          first_name: '',
          last_name: '',
          email: '',
          profile_photo_url: ''
        }
      },
      selectedFile: null,
      previewImage: this.institute && this.institute.user ? this.institute.user.profile_photo_url : '',
      locations: [],
      errorMessage: '',
      loading: false // Track loading state
    };
  },
  watch: {
    institute(newInstitute) {
      if (newInstitute) {
        this.localInstitute = { ...newInstitute };
        this.previewImage = newInstitute.user ? newInstitute.user.profile_photo_url : '';
      }
    }
  },
  mounted() {

      this.fetchLocations();
  },
  methods: {
    async fetchLocations() {
      try {
        const response = await axios.get('/get-all-locations');
        this.locations = response.data;
      } catch (error) {
        this.errorMessage = 'Error fetching locations.';
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.previewImage = URL.createObjectURL(file);
      }
    },
    async submitForm() {
      this.loading = true; // Set loading state to true
    try {
      const formData = new FormData();
      formData.append('institute_name', this.localInstitute.institute_name);
      formData.append('address', this.localInstitute.address);
      formData.append('contact', this.localInstitute.contact);
      formData.append('location_id', this.localInstitute.location_id);
      formData.append('first_name', this.localInstitute.user.first_name);
      formData.append('last_name', this.localInstitute.user.last_name);
      formData.append('email', this.localInstitute.user.email);
      formData.append('user_id', this.localInstitute.user.id); // Add user_id here

      if (this.selectedFile) {
        formData.append('profile_photo', this.selectedFile);
      }

      await axios.post('/update-institute', formData);
      this.$emit('update-institute', formData);
      alert('Institute updated successfully');
    } catch (error) {
      console.error('Error updating institute:', error);
      alert('Failed to update institute');
    } finally {
        this.loading = false; // Reset loading state after completion
      }
  }
  }
};
</script>

<style scoped>
.img-fluid {
  max-width: 100%;
  height: auto;
}
</style>
